// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"0c319633","476":"a8baac17","732":"ddd78fb0","837":"12427e63"}[chunkId] + ".chunk.js";
};